import React, { useContext } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { OrderFormContext } from '../../contexts'

const FrameSizeItem = ({
  isSelected,
  isGrayOut,
  onSelect,
  ...props
}) => {
  const {
    setHoveredFrameSize,
    setShowHoveredFrameSize
  } = useContext(OrderFormContext)

  const sizeSwatchHighlightStyle = {}

  if('matted-prints_8x12-in-12x16-rectangle' === props.name ||
      'matted-prints_5x7-in-8x10-rectangle' === props.name ||
      'matted-prints_8x10-in-11x14-rectangle' === props.name
  ) {
    sizeSwatchHighlightStyle.color = 'blue'
  }

  return (
    <div
      className={classnames('SizeSwatch', { isGrayOut, isSelected })}
      onClick={onSelect}
      onMouseEnter={() => {
        setShowHoveredFrameSize(true)
        setHoveredFrameSize(props)
      }}
      onMouseLeave={() => {
        setShowHoveredFrameSize(false)
      }}
    >
      <div className="SizeSwatch__Inner">
        <p className="SizeSwatch__Text" style={sizeSwatchHighlightStyle}>
          <span>{props.title}</span>
        </p>
      </div>
    </div>
  )
}

FrameSizeItem.propTypes = {
  isSelected: PropTypes.bool,
  isGrayOut: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  title: PropTypes.string
}

export default FrameSizeItem
